<template>
  <div class="field" :class="{ 'without-label': !helperText }">
    <div
      class="input"
      :data-placeholder="placeholder"
      :class="inputContainerClasses"
    >
      <slot v-bind="{ changeFocus }">
        <input
          type="text"
          v-bind="input"
          v-model="mutableValue"
          @focus="changeFocus(true)"
          @blur="changeFocus(false)"
        />
      </slot>
    </div>
    <label class="label" v-if="helperText">{{ helperText }}</label>
  </div>
</template>

<script>
export default {
  props: {
    hasBorder: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },

    placeholder: String,

    helperText: String,

    input: Object,

    value: null,

    id: null,
  },

  computed: {
    inputContainerClasses() {
      return {
        "has-border": this.hasBorder,
        "is-small": this.isSmall,
        "has-placeholder": !!this.placeholder,
        "is-focused": this.isFocused,
      };
    },
  },

  data() {
    return {
      isFocused: false,
      mutableValue: this.value,
    };
  },

  methods: {
    changeFocus(isFocused) {
      if (this.mutableValue || !this.Object) this.isFocused = true;
      else this.isFocused = isFocused;
    },
  },
};
</script>